import { render, staticRenderFns } from "./reading-course.vue?vue&type=template&id=3673998e&scoped=true&"
import script from "./reading-course.js?vue&type=script&lang=js&"
export * from "./reading-course.js?vue&type=script&lang=js&"
import style0 from "./reading-course.vue?vue&type=style&index=0&id=3673998e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673998e",
  null
  
)

export default component.exports